import { ref, onMounted, onUnmounted } from 'vue'
const useEventListener = (eventName, target = window) => {
  const event = ref(new CustomEvent(eventName))
  const handleEvent = e => {
    event.value = e
  }
  onMounted(() => target.addEventListener(eventName, handleEvent))
  onUnmounted(() => target.removeEventListener(eventName, handleEvent))
  return event
}
export default useEventListener
